<template>
    <div class="faq-block"  :class="{'close': close }">
        <span class="toggle-close" @click="toggleClose">
            <img :src="arrowImg" :style="{transform: 'rotate('+arrowRotate+'deg)'}" alt="">
        </span>
        <div @click="toggleClose" class="faq-title">
            <slot name="faq-title"></slot>
        </div>
        <div class="faq-body">
            <slot name="faq-body"></slot>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            arrowImg: require('../../../assets/img/icon/arrow_down_gray.svg'),
            arrowRotate: '0',
            close: this.isClose
        }
    },
    props:{
        isClose: ''
    },
    watch: {
        close: function () {
            if(this.close){
                this.arrowImg = require('../../../assets/img/icon/arrow_down_gray.svg'),
                this.arrowRotate = '0'
            }else{
                this.arrowImg = require('../../../assets/img/icon/arrow_down_black.svg'),
                this.arrowRotate = '180'
            }
        },
    },
    methods: {
        toggleClose: function () {
            this.close = !this.close
        },
    }
}
</script>
<style lang="scss" scoped>
    .faq-block{
        position: relative;
        width: 1152px;
        border-radius: 8px;
        border: solid 1px #f0f0f0;
        background-color: #ffffff;
        margin-bottom: 20px;
        .text__highlight{
            background-color: #ffe9e3;
        }
        .toggle-close{
            position: absolute;
            right: 20px;
            top: 20px;
            cursor: pointer;
        }
        >.faq-title{
            display: flex;
            align-items: center;
            font-size: 16px;
            padding: 20px;
            >img{
                margin-right: 4px;
            }
        }
        >.faq-body{
            font-weight: 300;
            width: 660px;
            line-height: 1.71;
            padding: 0 20px 20px 20px;
            >ul{
                >li{
                    margin-bottom: 12px;
                }
            }
        }
    }
    .faq-block.close{
        .faq-body{
            display: none;
        }
    }
    @media screen and (max-width: 1280px) {
        .faq-block{
            width: 1140px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/faq/FaqBlock.vue